/** Auto-generated fallback messages from /locale/en/*.json */
export const fallbackMessages: Record<string, string> = {
  'core.appointment.messages.rescheduledCountTimes': 'Rescheduled {count} times',
  'core.appointment.messages.rescheduledOnce': 'Rescheduled once',
  'core.appointment.messages.rescheduledTwice': 'Rescheduled twice',
  'core.customFields.descriptions.dateAndTimeFields': 'Date and time fields',
  'core.customFields.descriptions.emailAddressInputField': 'Email address input field',
  'core.customFields.descriptions.format1XxxXxxXxxx': 'Format +1(XXX) XXX-XXXX',
  'core.customFields.descriptions.formatMmDdYyyy': 'Format MM/DD/YYYY',
  'core.customFields.descriptions.linkToTheFormFeatures': 'Link to the form features',
  'core.customFields.descriptions.multipleFileUploadField': 'Multiple file upload field',
  'core.customFields.descriptions.numericInputField': ' Numeric input field',
  'core.customFields.descriptions.openTextFieldMultipleLines': 'Open text field, multiple lines',
  'core.customFields.descriptions.openTextFieldSingleLine': 'Open text field, single line',
  'core.customFields.descriptions.selectMultipleOptionsFromAList':
    'Select multiple options from a list',
  'core.customFields.descriptions.selectOneOptionFromAList': 'Select one option from a list',
  'core.customFields.descriptions.singleFileUploadField': 'Single file upload field',
  'core.customFields.descriptions.singleOptionDropDownListOpenTextField':
    'Single option drop-down list + open text field',
  'core.customFields.descriptions.toggleButton': 'Toggle Button',
  'core.customFields.labels.comboBox': 'Combo Box',
  'core.customFields.labels.date': 'Date',
  'core.customFields.labels.dropDownMultiSelectList': 'Drop-down Multi Select List',
  'core.customFields.labels.dropDownSingleSelectList': 'Drop-down Single Select List',
  'core.customFields.labels.eMail': 'E-mail',
  'core.customFields.labels.featureLink': 'Feature Link',
  'core.customFields.labels.multiDocument': 'Multi Document',
  'core.customFields.labels.number': 'Number',
  'core.customFields.labels.phone': 'Phone',
  'core.customFields.labels.singleDocument': 'Single Document',
  'core.customFields.labels.textMultipleLines': 'Text - Multiple Lines',
  'core.customFields.labels.textSingleLine': 'Text - Single Line',
  'core.customFields.labels.timestamp': 'Timestamp',
  'core.customFields.labels.trueFalse': 'True/False',
  'core.customForms.customFormsFeaturesData.descriptions.captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals':
    'Capture check-in details from drivers for both planned and unplanned arrivals.',
  'core.customForms.customFormsFeaturesData.descriptions.captureCheckOutDataAfterAnAppointmentIsCompleted':
    'Capture check-out data after an appointment is completed.',
  'core.customForms.customFormsFeaturesData.descriptions.captureLoadTypeSpecificDetailsDuringAppointmentScheduling':
    'Capture load type specific details during appointment scheduling.',
  'core.customForms.customFormsFeaturesData.descriptions.collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution':
    'Collect driver info as they self check-in for their planned appointment. This feature is an optional add-on to our Gate Management solution.',
  'core.customForms.customFormsFeaturesData.descriptions.documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad':
    'Document damage, discrepancies or other issues related to the received load.',
  'core.customForms.customFormsFeaturesData.descriptions.documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad':
    'Document load integrity and other security measures related to the shipped load.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn':
    'Enable the Gate Management module for this warehouse, which includes the check-in',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheIdValidationForThisWarehouse':
    'Enable the ID Validation module for this warehouse.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheSmartGateModuleForThisWarehouse':
    'Enable the SmartGate module for this warehouse.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp':
    'Enable the YMS module for this warehouse, also enable the asset visit fields for the gate management app.',
  'core.customForms.customFormsFeaturesData.descriptions.reviewAndManageAppointmentDataAfterCompletion':
    'Review and manage appointment data after completion.',
  'core.customForms.customFormsFeaturesData.descriptions.storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard':
    'Store and track details of trailers and containers as they arrive at your yard.',
  'core.customForms.customFormsFeaturesData.disableDisclaimers.allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime':
    'All Fields on this form will be <strong>unavailable</strong> during appointment scheduling.<br />You can re-enable this form at any time.',
  'core.customForms.customFormsFeaturesData.disableDisclaimers.theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn':
    'The drivers will not see this form when they are checking themselves in.',
  'core.customForms.customFormsFeaturesData.enableDisclaimers.allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling':
    'All Fields on this form will be <strong>available and visible</strong> during appointment scheduling.',
  'core.customForms.customFormsFeaturesData.enableDisclaimers.theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn':
    'The drivers will see this form when they are checking themselves in.',
  'core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorks':
    '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works.</a>',
  'core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorksOrContactUsToRequestATrial':
    '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works</a> or contact us to <a href="https://lp.opendock.com/gate-management" target="_blank">request a trial.</a>.',
  'core.customForms.customFormsFeaturesData.labels.damageDescription': 'Damage Description',
  'core.customForms.customFormsFeaturesData.labels.damagePhotos': 'Damage Photos',
  'core.customForms.customFormsFeaturesData.labels.damageType': 'Damage Type',
  'core.customForms.customFormsFeaturesData.labels.discrepancyDescription':
    'Discrepancy Description',
  'core.customForms.customFormsFeaturesData.labels.discrepancyPhotos': 'Discrepancy Photos',
  'core.customForms.customFormsFeaturesData.labels.discrepancyType': 'Discrepancy Type',
  'core.customForms.customFormsFeaturesData.labels.loadIntegrityPhotos': 'Load Integrity Photos',
  'core.customForms.customFormsFeaturesData.labels.loadSecurityChecked': 'Load Security Checked',
  'core.customForms.customFormsFeaturesData.labels.loadSecurityDescription':
    'Load Security Description',
  'core.customForms.customFormsFeaturesData.labels.sealIntegrityPhotos': 'Seal Integrity Photos',
  'core.customForms.customFormsFeaturesData.labels.selectAClaimsSupportToUpdate':
    'Select a Claims Support to update',
  'core.customForms.customFormsFeaturesData.labels.updateClaimsSupport': 'Update Claims Support',
  'core.customForms.customFormsFeaturesData.subtitles.phoneNumberAndCarrierCompanyWillBeCollectedByDefault':
    '<strong>Phone number</strong> and <strong>carrier company</strong> will be collected by default',
  'core.customForms.customFormsFeaturesData.titles.appointmentCompleted': 'Appointment Completed',
  'core.customForms.customFormsFeaturesData.titles.appointmentsPerLoadType':
    'Appointments per Load Type',
  'core.customForms.customFormsFeaturesData.titles.assetDetails': 'Asset Details',
  'core.customForms.customFormsFeaturesData.titles.checkIn': 'Check-in',
  'core.customForms.customFormsFeaturesData.titles.checkInDeprecated': 'Check-in (Deprecated)',
  'core.customForms.customFormsFeaturesData.titles.checkOut': 'Check-Out',
  'core.customForms.customFormsFeaturesData.titles.gateManagement': 'Gate Management',
  'core.customForms.customFormsFeaturesData.titles.idValidation': 'ID Validation',
  'core.customForms.customFormsFeaturesData.titles.receivedLoadInspection':
    'Received Load Inspection',
  'core.customForms.customFormsFeaturesData.titles.shippedLoadVerification':
    'Shipped Load Verification',
  'core.customForms.customFormsFeaturesData.titles.smartGateIntegration': 'SmartGate integration',
  'core.customForms.customFormsFeaturesData.titles.yardManagementSystem': 'Yard Management System',
  'core.global.entities.loadtypes': 'Load Type | Load Types',
  'core.global.entities.organizations': 'Organization | Organizations',
  'core.global.entities.orgs': 'Org | Orgs',
  'core.global.entities.warehouses': 'Warehouse | Warehouses',
  'core.notifications.anchorLabels.appointmentCancelled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentCompleted': 'View Appointment',
  'core.notifications.anchorLabels.appointmentConfirmed': 'View Appointment',
  'core.notifications.anchorLabels.appointmentDetailsHaveChanged': 'View Appointment',
  'core.notifications.anchorLabels.appointmentIsInProgressAtFacility': 'View Appointment',
  'core.notifications.anchorLabels.appointmentRequested': 'View Appointment',
  'core.notifications.anchorLabels.appointmentRescheduled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentScheduled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentTagged': 'View Appointment',
  'core.notifications.anchorLabels.assetReadyForPickup': 'View Appointment',
  'core.notifications.anchorLabels.missedAppointment': 'View Appointment',
  'core.notifications.anchorLabels.recurringAppointmentSeriesCreated': 'View Original Appointment',
  'core.notifications.anchorLabels.truckArrivedAtFacility': 'View Appointment',
  'core.notifications.contextLabels.assetReadyForPickup.amenitiesLabel': 'Amenities available',
  'core.notifications.contextLabels.assetReadyForPickup.appointmentDetailsLabel':
    'Appointment Details',
  'core.notifications.contextLabels.assetReadyForPickup.carrierContactLabel': 'Carrier Contact',
  'core.notifications.contextLabels.assetReadyForPickup.dockDoorLabel': 'Dock Door',
  'core.notifications.contextLabels.assetReadyForPickup.dockInstructionsLabel': 'Dock Instructions',
  'core.notifications.contextLabels.assetReadyForPickup.idLabel': 'Confirmation Number',
  'core.notifications.contextLabels.assetReadyForPickup.loadTypeLabel': 'Load Type',
  'core.notifications.contextLabels.assetReadyForPickup.noPickupScheduledLabel':
    'No pickup appointment scheduled',
  'core.notifications.contextLabels.assetReadyForPickup.openInGoogleMapsLabel':
    'Open in Google Maps',
  'core.notifications.contextLabels.assetReadyForPickup.ownedByLabel': 'Owned by:',
  'core.notifications.contextLabels.assetReadyForPickup.pickupScheduledForLabel':
    'Pickup scheduled for:',
  'core.notifications.contextLabels.assetReadyForPickup.ppeRequirementsLabel':
    'PPE & other requirements',
  'core.notifications.contextLabels.assetReadyForPickup.schedulingAnchorLabel': 'Schedule Pickup',
  'core.notifications.contextLabels.assetReadyForPickup.storeLabel': 'Store',
  'core.notifications.contextLabels.assetReadyForPickup.warehouseInstructionsLabel':
    'Warehouse Instructions',
  'core.notifications.descriptions.appointmentTagged':
    'Use Appointment Tags setting to enable tags individually',
  'core.notifications.subTitles.appointmentCancelled':
    'Please check all details and reason for cancellation.',
  'core.notifications.subTitles.appointmentCompleted':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentConfirmed':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentDetailsHaveChanged':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentIsInProgressAtFacility':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentRequested': 'Please wait for warehouse confirmation.',
  'core.notifications.subTitles.appointmentRescheduled':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentScheduled':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentTagged':
    'Please check the tag name and information below.',
  'core.notifications.subTitles.assetReadyForPickup':
    'An asset at your facility is ready for pickup.',
  'core.notifications.subTitles.missedAppointment': 'Carrier did not show for the appointment.',
  'core.notifications.subTitles.recurringAppointmentSeriesCreated':
    'Please check the details of the recurring appointment below.',
  'core.notifications.subTitles.truckArrivedAtFacility':
    'Check the status and appointment details below.',
  'core.notifications.subjects.appointmentCancelled':
    'Appointment cancelled with {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentCompleted':
    'Appointment completed at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentConfirmed':
    'Appointment confirmed at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentDetailsHaveChanged': 'Appointment details have changed',
  'core.notifications.subjects.appointmentIsInProgressAtFacility':
    'Appointment is in progress at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentRequested':
    'Appointment requested at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentRescheduled':
    'Appointment rescheduled at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentScheduled':
    'Appointment scheduled at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentTagged':
    'Appointment tagged as {tagName} - {warehouseName}',
  'core.notifications.subjects.assetReadyForPickup':
    'Ready for Pickup - Container {containerNumber}',
  'core.notifications.subjects.missedAppointment':
    'Missed appointment at {orgName} - {warehouseName}',
  'core.notifications.subjects.recurringAppointmentSeriesCreated':
    'Recurring appointment series has been created',
  'core.notifications.subjects.truckArrivedAtFacility':
    'Truck arrived at {orgName} - {warehouseName}',
  'core.notifications.titles.appointmentCancelled': 'Appointment cancelled',
  'core.notifications.titles.appointmentCompleted': 'Appointment completed',
  'core.notifications.titles.appointmentConfirmed': 'Appointment confirmed',
  'core.notifications.titles.appointmentDetailsHaveChanged': 'Appointment details have changed',
  'core.notifications.titles.appointmentIsInProgressAtFacility':
    'Appointment is in progress at facility',
  'core.notifications.titles.appointmentRequested': 'Appointment requested',
  'core.notifications.titles.appointmentRescheduled': 'Appointment rescheduled',
  'core.notifications.titles.appointmentScheduled': 'Appointment scheduled',
  'core.notifications.titles.appointmentTagged': 'Appointment tagged',
  'core.notifications.titles.assetReadyForPickup': 'Asset ready for pickup',
  'core.notifications.titles.missedAppointment': 'Missed appointment',
  'core.notifications.titles.recurringAppointmentSeriesCreated':
    'Recurring appointment series created',
  'core.notifications.titles.truckArrivedAtFacility': 'Truck arrived at facility',
  'core.settings.descriptions.aListOfMutedAppointmentNotifications':
    'A list of muted appointment notifications.',
  'core.settings.descriptions.additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx':
    'Additional information to help fill in the Reference Number field.  Eg: "Reference Number should start with OD-XX"',
  'core.settings.descriptions.additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers':
    'Additional information to help fill in the unit type field. Eg: Unit Type should be only numbers',
  'core.settings.descriptions.allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal':
    'Allow Dock selection when booking an appointment in the Scheduling Portal',
  'core.settings.descriptions.attributeToBeUsedForMatchingObservations':
    'Attribute to be used for matching observations',
  'core.settings.descriptions.autoDepartAssetsOnReceivingOutgateEvent':
    'Auto depart assets on receiving outgate event',
  'core.settings.descriptions.createAppointmentsEvenIfAppointmentValidationDoesNotPass':
    'Create appointments even if appointment validation does not pass',
  'core.settings.descriptions.determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences':
    'Determine how dates will be displayed for users of this company across company-facing experiences.',
  'core.settings.descriptions.determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports':
    'Determine how time will be displayed across the platform for all users of this Org, including the appointments grid and reports.',
  'core.settings.descriptions.determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences':
    'Determine how time will be displayed for users of this company across company-facing experiences.',
  'core.settings.descriptions.driverMustPrintTheBolToCompleteTheCheckoutWithAPhysicalSignature':
    'Driver must print the BOL to complete the checkout with a physical signature.',
  'core.settings.descriptions.emailAddressWhereTechnicalIssuesAndInformationWillBeSent':
    'Email address where technical issues and information will be sent',
  'core.settings.descriptions.enableTheCustomAppointmentStartTimesSetting':
    'Enable the custom appointment start times setting',
  'core.settings.descriptions.enableToSwitchToTheNewCustomizableAppointmentDetailsSystem':
    'Enable to switch to the new customizable appointment details system',
  'core.settings.descriptions.enforceBolSigningOnCheckOutForm':
    'Enforce BOL signing on check-out form',
  'core.settings.descriptions.errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut':
    'If the BOL is not available, the carrier will not be able to sign it, thus the check-out would be blocked. Here, you can set custom instructions that the driver will see in case this happens.',
  'core.settings.descriptions.numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted':
    'Number of days a stored ID validation is kept before it is deleted',
  'core.settings.descriptions.personaTemplateUsedForCheckInIdentityVerification':
    'Persona template used for check-in identity verification',
  'core.settings.descriptions.preventCarriersFromReschedulingAppointmentsOptional':
    'Prevent carriers from rescheduling appointments. (optional)',
  'core.settings.descriptions.requireAtLeastThisAmountOfReferenceNumbersForAnAppointment':
    'Require at least this amount of reference numbers for an appointment',
  'core.settings.descriptions.requireAtMostThisAmountOfReferenceNumbersForAnAppointment':
    'Require at most this amount of reference numbers for an appointment',
  'core.settings.descriptions.requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn':
    'Require successful Persona validation before the driver can complete check-in',
  'core.settings.descriptions.requireTheReferenceNumberForAllAppointmentsBeingScheduled':
    'Require the Reference Number for all appointments being scheduled',
  'core.settings.descriptions.requireTheUnitTypeFieldForAllAppointmentsBeingScheduled':
    'Require the unit type field for all appointments being scheduled',
  'core.settings.descriptions.requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled':
    'Require unique Reference Numbers for all appointments being scheduled',
  'core.settings.descriptions.sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse':
    'Sends your Yard Map as a separate image message right after the check-in SMS. Requires a Yard Map to be uploaded for this warehouse.',
  'core.settings.descriptions.setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment':
    'Sets the maximum numeric value that can be entered for the Handling Units field on an appointment',
  'core.settings.descriptions.setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment':
    'Sets the minimum numeric value that can be entered for the Handling Units field on an appointment',
  'core.settings.descriptions.showThePersonaComponentInTheCheckInFlowForIdentityVerification':
    'Show the Persona component in the check-in flow for identity verification',
  'core.settings.descriptions.storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed':
    'Stored ID validation records are permanently deleted once the retention period has passed',
  'core.settings.descriptions.theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm':
    'The asset attribute the system will use to validate the check-out form',
  'core.settings.descriptions.theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId':
    'The display name for the Reference Number field. Eg: "PO Number", "Shipment ID"',
  'core.settings.descriptions.theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount':
    'The display name for the unit type field. Eg: Pallet Count, Skid Count',
  'core.settings.descriptions.theDistanceUnitTheGeofenceRadiusIsMeasuredIn':
    'The distance unit the geofence radius is measured in.',
  'core.settings.descriptions.theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal':
    'The duration is displayed on the Load Types select list booking an appointment in the Scheduling Portal',
  'core.settings.descriptions.theInputModeForTheReferenceNumberField':
    'The input mode for the reference number field',
  'core.settings.descriptions.theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn':
    'The number of minutes after the appointment start time that a carrier can check in',
  'core.settings.descriptions.theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn':
    'The number of minutes before the appointment start time that a carrier can check in',
  'core.settings.descriptions.theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime':
    'The number of minutes to account for an observation before and after the check-in time',
  'core.settings.descriptions.theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled':
    'The radius in miles that the driver must be within to check in. This is only applicable if geofencing is enabled.',
  'core.settings.descriptions.theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs':
    'The time between notifications sent to the technical contact when a validation server error occurs.',
  'core.settings.descriptions.thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart':
    'This is the interval minutes between when appointments can start',
  'core.settings.descriptions.thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage':
    'This message replaces the default check-in confirmation text sent to the driver by SMS. Leave blank to use the default message.',
  'core.settings.descriptions.thisOnlyAffectsNewlyCreatedAppointments':
    'This only affects newly created appointments',
  'core.settings.descriptions.thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse':
    'This setting asks for the drivers location and restricts them from checking-in when they are more than one mile away from your warehouse.',
  'core.settings.descriptions.thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted':
    "This setting will allow the choice of an alternate 'In Progress' status between 'Arrived' and 'Completed'",
  'core.settings.descriptions.userConfigurationOfHowGridTilesWillBeDisplayed':
    'User configuration of how grid tiles will be displayed.',
  'core.settings.descriptions.warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs':
    'Warehouse subscribers receive email notifications when an unplanned check-in occurs',
  'core.settings.descriptions.whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval':
    'When a carrier reschedules a Scheduled appointment, move it back to Requested for re-approval',
  'core.settings.descriptions.whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits':
    'When the limiter is 100% reached, this feature allows only warehouse users to override and create or approve appointments and units',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.customStartTimes':
    'Custom start times',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyQuarterOfTheHour001530And45':
    'Every quarter of the hour (:00, :15, :30, and :45)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyTwentyMinutes0020And40':
    'Every Twenty Minutes (:00, :20, and :40)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topAndBottomOfTheHour00And30':
    'Top and bottom of the hour (:00 and :30)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topOfTheHour00':
    'Top of the hour (:00)',
  'core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.noDontAllowDockSelection':
    "No, don't allow Dock selection",
  'core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.yesAllowTheDockSelection':
    'Yes, allow the Dock selection',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.15Minutes': '15 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.30Minutes': '30 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.60Minutes': '60 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.90Minutes': '90 Minutes',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseFront1Retry':
    'Driver license - Front - 1 retry',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseFrontBarcodeFaceUsOnly1Retry':
    'Driver license - Front, barcode, face, us only, 1 retry',
  'core.settings.dropdownOptions.checkOutIdentifier.any': 'Any',
  'core.settings.dropdownOptions.checkOutIdentifier.licensePlate': 'License Plate',
  'core.settings.dropdownOptions.checkOutIdentifier.phoneNumber': 'Phone Number',
  'core.settings.dropdownOptions.displayDatesAs.ddMmYyyy': 'DD/MM/YYYY',
  'core.settings.dropdownOptions.displayDatesAs.mmDdYyyy': 'MM/DD/YYYY',
  'core.settings.dropdownOptions.displayDatesAs.tueDdMmYyyy': 'Tue, DD/MM/YYYY',
  'core.settings.dropdownOptions.displayDatesAs.tueMmDdYyyy': 'Tue, MM/DD/YYYY',
  'core.settings.dropdownOptions.displayDatesAs.tueYyyyMmDd': 'Tue, YYYY-MM-DD',
  'core.settings.dropdownOptions.displayDatesAs.yyyyMmDd': 'YYYY-MM-DD',
  'core.settings.dropdownOptions.displayTimeAs.12HourEG700Am': '12-hour (e.g. 7:00 AM)',
  'core.settings.dropdownOptions.displayTimeAs.24HourEG0700': '24-hour (e.g. 07:00)',
  'core.settings.dropdownOptions.displayTimeIn.militaryTime24Hour': 'Military time (24-hour)',
  'core.settings.dropdownOptions.displayTimeIn.regularTime12Hour': 'Regular time (12-hour)',
  'core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.noDisableAppointmentNotifications':
    'No, disable appointment notifications',
  'core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.yesEnableAppointmentNotifications':
    'Yes, enable appointment notifications',
  'core.settings.dropdownOptions.enableCheckInIdValidationPersona.no': 'No',
  'core.settings.dropdownOptions.enableCheckInIdValidationPersona.yes': 'Yes',
  'core.settings.dropdownOptions.geofenceRadiusUnit.kilometers': 'Kilometers',
  'core.settings.dropdownOptions.geofenceRadiusUnit.miles': 'Miles',
  'core.settings.dropdownOptions.hideTheLoadTypeDuration.noDontHideTheLoadTypeDuration':
    "No, don't hide the Load Type duration",
  'core.settings.dropdownOptions.hideTheLoadTypeDuration.yesHideTheLoadTypeDuration':
    'Yes, hide the Load Type duration',
  'core.settings.dropdownOptions.includeHandlingUnitsFieldOnAllAppointmentForms.noDontIncludeTheHandlingUnitsField':
    "No, don't include the Handling Units field",
  'core.settings.dropdownOptions.includeHandlingUnitsFieldOnAllAppointmentForms.yesIncludeTheHandlingUnitsField':
    'Yes, include the Handling Units field',
  'core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.noDontIncludeTheReferenceNumberField':
    "No, don't include the Reference Number field",
  'core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.yesIncludeTheReferenceNumberField':
    'Yes, include the Reference Number field',
  'core.settings.dropdownOptions.makeHandlingUnitsARequiredField.noDontMakeHandlingUnitsARequiredField':
    "No, don't make Handling Units a required field",
  'core.settings.dropdownOptions.makeHandlingUnitsARequiredField.yesMakeHandlingUnitsARequiredField':
    'Yes, make Handling Units a required field',
  'core.settings.dropdownOptions.makeReferenceNumberARequiredField.noDontMakeReferenceNumberARequiredField':
    "No, don't make Reference Number a required field",
  'core.settings.dropdownOptions.makeReferenceNumberARequiredField.yesMakeReferenceNumberARequiredField':
    'Yes, make Reference Number a required field',
  'core.settings.dropdownOptions.observationMatchAttribute.any': 'Any',
  'core.settings.dropdownOptions.observationMatchAttribute.cascade': 'Cascade',
  'core.settings.dropdownOptions.observationMatchAttribute.dotNumber': 'DOT Number',
  'core.settings.dropdownOptions.observationMatchAttribute.licensePlate': 'License Plate',
  'core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.allowReschedulingInTheSchedulingPortal':
    'Allow rescheduling in the Scheduling Portal ',
  'core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.preventReschedulingInTheSchedulingPortal':
    'Prevent rescheduling in the Scheduling Portal',
  'core.settings.dropdownOptions.receiveUnplannedCheckInEmailNotifications.no': 'No',
  'core.settings.dropdownOptions.receiveUnplannedCheckInEmailNotifications.yes': 'Yes',
  'core.settings.dropdownOptions.referenceNumberInputMode.alphanumeric': 'Alphanumeric',
  'core.settings.dropdownOptions.referenceNumberInputMode.numeric': 'Numeric',
  'core.settings.dropdownOptions.requireCheckInIdValidationToCompleteCheckIn.no': 'No',
  'core.settings.dropdownOptions.requireCheckInIdValidationToCompleteCheckIn.yes': 'Yes',
  'core.settings.dropdownOptions.requireUniqueReferenceNumbers.noDontRequireUniqueReferenceNumbers':
    "No, don't require unique Reference Numbers",
  'core.settings.dropdownOptions.requireUniqueReferenceNumbers.yesRequireUniqueReferenceNumbers':
    'Yes, require unique Reference Numbers',
  'core.settings.dropdownOptions.revertToRequestedOnCarrierReschedule.keepStatusUnchangedOnCarrierReschedule':
    'Keep status unchanged on carrier reschedule',
  'core.settings.dropdownOptions.revertToRequestedOnCarrierReschedule.revertToRequestedOnCarrierReschedule':
    'Revert to Requested on carrier reschedule',
  'core.settings.dropdownOptions.statusForNewlyCreatedAppointments.requested': 'Requested',
  'core.settings.dropdownOptions.statusForNewlyCreatedAppointments.scheduled': 'Scheduled',
  'core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.completed': 'Completed',
  'core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.inProgress': 'In Progress',
  'core.settings.examples.displayTimeIn.eG07001900': 'E.g. 07:00 / 19:00',
  'core.settings.examples.displayTimeIn.eG700Am700Pm': 'E.g. 7:00 AM / 7:00 PM',
  'core.settings.groupDescriptions.determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart':
    'Determine the time intervals at which appointments will be allowed to start.',
  'core.settings.groupDescriptions.handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature':
    'Handling Units is a numeric field for requesting units (e.g. pallets) during appointment scheduling. Add it to your form to also enable the Limiter feature.',
  'core.settings.groupDescriptions.manageAllTypesOfAppointmentNotificationsForThisEntity':
    'Manage all types of appointment notifications for this {entity}.',
  'core.settings.groupDescriptions.manageTheSchedulingPortalSettingsForThisEntity':
    'Manage the Scheduling Portal settings for this {entity}',
  'core.settings.groupDescriptions.referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment':
    "Reference Number is the reference you can request from carriers when they're scheduling an appointment.",
  'core.settings.groupDescriptions.theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay':
    'The Limiter allows you to set a maximum number of appointments or handling units (e.g. pallets) that can be scheduled per day.',
  'core.settings.groups.appointmentNotifications': 'Appointment Notifications',
  'core.settings.groups.appointmentStartTimes': 'Appointment Start Times',
  'core.settings.groups.appointmentStatuses': 'Appointment Statuses',
  'core.settings.groups.appointmentValidation': 'Appointment Validation',
  'core.settings.groups.customAppointmentsGrid': 'Custom Appointments Grid',
  'core.settings.groups.dockSelection': 'Dock Selection',
  'core.settings.groups.gateManagement': 'Gate Management',
  'core.settings.groups.handlingUnits': 'Handling Units',
  'core.settings.groups.idValidation': 'ID Validation',
  'core.settings.groups.limiter': 'Limiter',
  'core.settings.groups.other': 'Other',
  'core.settings.groups.referenceNumber': 'Reference Number',
  'core.settings.groups.schedulingPortal': 'Scheduling Portal',
  'core.settings.groups.smartGate': 'SmartGate',
  'core.settings.groups.timeDisplay': 'Time Display',
  'core.settings.labels.allowAppointmentsForThisEntityToStartAt':
    'Allow appointments for this {entity} to start at:',
  'core.settings.labels.allowDockSelectionInSchedulingPortal':
    'Allow Dock selection in Scheduling Portal?',
  'core.settings.labels.appointmentStartTimeInterval': 'Appointment Start Time Interval',
  'core.settings.labels.autoDepartAssets': 'Auto depart Assets',
  'core.settings.labels.automaticallyDeleteStoredIdValidations':
    'Automatically delete stored ID validations',
  'core.settings.labels.checkInEarlyThreshold': 'Check-in Early Threshold',
  'core.settings.labels.checkInIdValidationTemplate': 'Check-in ID validation template',
  'core.settings.labels.checkInLateThreshold': 'Check-in Late Threshold',
  'core.settings.labels.checkOutBolNotLoadingErrorMessage':
    'Check-out BOL not loading error message',
  'core.settings.labels.checkOutBolSignedRequired': 'Check-out BOL Signed Required',
  'core.settings.labels.checkOutIdentifier': 'Check-out Identifier',
  'core.settings.labels.createAppointmentOnExternalValidationFailure':
    'Create appointment on external validation failure',
  'core.settings.labels.customizeAppointmentDetails': 'Customize appointment details',
  'core.settings.labels.customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional':
    'Customize the first SMS message drivers receive after check-in (optional)',
  'core.settings.labels.deleteStoredIdValidationsAfter': 'Delete stored ID validations after',
  'core.settings.labels.displayDatesAs': 'Display dates as:',
  'core.settings.labels.displayTimeAs': 'Display time as:',
  'core.settings.labels.displayTimeIn': 'Display time in:',
  'core.settings.labels.driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment':
    'Drivers can only check in if the reference number matches the scheduled appointment',
  'core.settings.labels.driversMustEnterAReferenceNumberToCheckIn':
    'Drivers must enter a reference number to check in',
  'core.settings.labels.driversSkipTheReferenceNumberStepDuringCheckIn':
    'Drivers skip the reference number step during check-in',
  'core.settings.labels.enableAppointmentNotificationsForThisEntity':
    'Enable appointment notifications for this {entity}?',
  'core.settings.labels.enableCheckInIdValidationPersona':
    'Enable check-in ID validation (Persona)',
  'core.settings.labels.enableOverrideLimiterFunction': 'Enable Override Limiter Function',
  'core.settings.labels.enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation':
    'Enforce geofencing to require drivers to provide their real time location',
  'core.settings.labels.geofenceRadius': 'Geofence Radius',
  'core.settings.labels.geofenceRadiusUnit': 'Geofence Radius Unit',
  'core.settings.labels.gridTileConfig': 'Grid tile config',
  'core.settings.labels.handlingUnitsHelperText': 'Handling Units Helper Text',
  'core.settings.labels.handlingUnitsLabel': 'Handling Units Label',
  'core.settings.labels.hideTheLoadTypeDuration': 'Hide the load type duration?',
  'core.settings.labels.includeHandlingUnitsFieldOnAllAppointmentForms':
    'Include Handling Units field on all appointment forms?',
  'core.settings.labels.includeReferenceNumberFieldOnAllAppointmentForms':
    'Include Reference Number field on all appointment forms?',
  'core.settings.labels.includeYardMapImageInTheFirstCheckInSms':
    'Include Yard Map image in the first check-in SMS?',
  'core.settings.labels.makeHandlingUnitsARequiredField': 'Make Handling Units a required field?',
  'core.settings.labels.makeReferenceNumberARequiredField':
    'Make Reference Number a required field?',
  'core.settings.labels.maximumAmountOfReferenceNumbers': 'Maximum Amount of Reference Numbers',
  'core.settings.labels.maximumHandlingUnitsValueForAnAppointment':
    'Maximum Handling Units value for an appointment',
  'core.settings.labels.minimumAmountOfReferenceNumbers': 'Minimum Amount of Reference Numbers',
  'core.settings.labels.minimumHandlingUnitsValueForAnAppointment':
    'Minimum Handling Units value for an appointment',
  'core.settings.labels.muteAppointmentNotifications': 'Mute Appointment Notifications',
  'core.settings.labels.observationMatchAttribute': 'Observation Match Attribute',
  'core.settings.labels.observationMatchTimeWindow': 'Observation Match Time Window',
  'core.settings.labels.preventReschedulingAppointmentsInTheSchedulingPortal':
    'Prevent rescheduling appointments in the Scheduling Portal?',
  'core.settings.labels.receiveUnplannedCheckInEmailNotifications':
    'Receive Unplanned Check-in Email Notifications',
  'core.settings.labels.referenceNumberFieldName': 'Reference Number field name',
  'core.settings.labels.referenceNumberHelperText': 'Reference Number helper text',
  'core.settings.labels.referenceNumberInputMode': 'Reference Number Input Mode',
  'core.settings.labels.requireBolPrinting': 'Require BOL Printing',
  'core.settings.labels.requireCheckInIdValidationToCompleteCheckIn':
    'Require check-in ID validation to complete check-in',
  'core.settings.labels.requireUniqueReferenceNumbers': 'Require Unique Reference Numbers',
  'core.settings.labels.revertToRequestedOnCarrierReschedule':
    'Revert to Requested on carrier reschedule',
  'core.settings.labels.selectEachDesiredStartTimeIndividually':
    'Select each desired start time individually',
  'core.settings.labels.statusForNewlyCreatedAppointments': 'Status for newly created appointments',
  'core.settings.labels.technicalContactEmailAddress': 'Technical Contact Email Address',
  'core.settings.labels.technicalContactEmailThrottleMinutes':
    'Technical Contact Email Throttle Minutes',
  'core.settings.labels.theStatusThatFollowsArrivedIs': "The status that follows 'Arrived' is",
  'core.settings.labels.uploadWarehouseYardMap':
    'Upload your warehouse yard map to display it in the Scheduling Portal',
  'core.settings.labels.uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications':
    'Upload your {entity} logo to display it in the Scheduling Portal and in all email notifications',
  'core.settings.labels.uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal':
    'Upload your warehouse yard map to display it in the Scheduling Portal',
  'core.settings.labels.wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional':
    'Would you like to show additional information to the drivers after they check in? (optional)',
  'core.settings.notes.enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually':
    'Enabling this option does not impact notifications that are already disabled on the appointment level individually.',
  'core.settings.notes.ifEmptyTheDefaultNameWillBeApplied':
    'If empty, the default name will be applied',
  'core.settings.notes.ifLeftEmptyNoNotificationsWillBeSent':
    'If left empty, no notifications will be sent',
  'core.settings.notes.ifLeftEmptyTheDefaultHelperTextWillBeApplied':
    'If left empty, the default helper text will be applied',
  'core.settings.notes.ifLeftEmptyTheDefaultNameWillBeApplied':
    'If left empty, the default name will be applied',
  'core.settings.notes.notesPrefix': 'Note:',
  'core.settings.notes.referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments':
    'Reference number assigned to cancelled or no show appointments may be reused on new appointments',
  'core.settings.placeholders.insertMessageHere': 'Insert message here',
  'core.settings.placeholders.referenceNumberAssociatedWithAppointment':
    'Reference Number associated with appointment',
  'core.settings.sectionLabels.checkInSms': 'Check-in SMS',
  'core.settings.sectionLabels.dataRetention': 'Data Retention',
  'core.settings.sectionLabels.drivers': 'Drivers',
  'core.user.descriptions.allPermissionsAndFullControlOverAllAccounts':
    'All permissions and full control over all accounts.',
  'core.user.descriptions.allPermissionsAndFullControlOverTheOrganizationAccount':
    'All permissions and full control over the Organization account.',
  'core.user.descriptions.baseUserAccount': 'Base user account.',
  'core.user.descriptions.carrierAdministrator': 'Carrier administrator.',
  'core.user.descriptions.carrierUser': 'Carrier user',
  'core.user.descriptions.createEditCancelAppointments': 'Create/edit/cancel Appointments.',
  'core.user.descriptions.createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners':
    'Create/edit/delete Appointments, Warehouses, Load Types, Docks, and Users (except Owners).',
  'core.user.descriptions.editAppointmentStatusTagsAndSubscribers':
    'Edit Appointment Status, tags, and subscribers.',
  'core.user.descriptions.godRoleWithLessControl': 'GOD role with less control.',
  'core.user.descriptions.viewOnlyNoCreateOrEditActionsAllowed':
    'View only. No create or edit actions allowed.',
  'core.user.descriptions.warehouseDriverHasLimitedAccessToTheApplication':
    'Warehouse driver, has limited access to the application.',
  'core.user.errors.mustContainAtLeastOneLetter': 'Must contain at least one letter',
  'core.user.errors.mustContainAtLeastOneNumber': 'Must contain at least one number',
  'core.user.errors.mustContainAtLeastOneSpecialCharacter':
    'Must contain at least one special character',
  'core.user.errors.mustContainUpperCaseAndLowerCase': 'Must contain upper-case and lower-case',
  'core.user.errors.mustHaveAtLeast8Characters': 'Must have at least 8 characters',
  'core.user.errors.yourRoleDoesNotAllowThisAction': 'Your role does not allow you to {action}',
  'core.user.errors.yourRoleDoesNotAllowYouToPerformThisAction':
    'Your role does not allow you to perform this action',
  'core.yard.altAssetVisitTypes.unknown': 'Unknown',
  'core.yard.assetContainerEvent.types.arrived': 'Arrived',
  'core.yard.assetContainerEvent.types.arrivedWaiting': 'Arrived/Waiting',
  'core.yard.assetContainerEvent.types.departed': 'Departed',
  'core.yard.assetContainerEvent.types.inTransit': 'In Transit',
  'core.yard.assetContainerEvent.types.inoperable': 'Inoperable',
  'core.yard.assetContainerEvent.types.loading': 'Loading',
  'core.yard.assetContainerEvent.types.loadingComplete': 'Loading Complete',
  'core.yard.assetContainerEvent.types.missing': 'Missing',
  'core.yard.assetContainerEvent.types.readyForPickup': 'Ready for Pickup',
  'core.yard.assetContainerEvent.types.unloading': 'Unloading',
  'core.yard.assetContainerEvent.types.unloadingComplete': 'Unloading Complete',
  'core.yard.assetContainerStates.empty': 'Empty',
  'core.yard.assetContainerStates.full': 'Full',
  'core.yard.assetContainerStates.partiallyLoaded': 'Partially Loaded',
  'core.yard.assetContainerTypes.chassis': 'Chassis',
  'core.yard.assetContainerTypes.container': 'Container',
  'core.yard.assetContainerTypes.other': 'Other',
  'core.yard.assetContainerTypes.oversized': 'Oversized',
  'core.yard.assetContainerTypes.reefer': 'Reefer',
  'core.yard.assetContainerTypes.trailer': 'Trailer',
  'core.yard.assetVisitDirections.inbound': 'Inbound',
  'core.yard.assetVisitDirections.inboundAndOutbound': 'In & Out',
  'core.yard.assetVisitDirections.outbound': 'Outbound',
  'core.yard.assetVisitTypes.drop': 'Drop',
  'core.yard.assetVisitTypes.dropHook': 'Drop & Hook',
  'core.yard.assetVisitTypes.live': 'Live',
  'core.yard.assetVisitTypes.pickup': 'Hook',
  'core.yard.assetVisitYardEvent.Appointment Linked': 'Appointment Linked',
  'core.yard.assetVisitYardEvent.Appointment Unlinked': 'Appointment Unlinked',
  'core.yard.assetVisitYardEvent.Arrived': 'Arrived',
  'core.yard.assetVisitYardEvent.Docked': 'Docked',
  'core.yard.assetVisitYardEvent.Dropped': 'Dropped',
  'core.yard.assetVisitYardEvent.Hooked': 'Hooked',
  'core.yard.assetVisitYardEvent.Parked': 'Parked',
  'core.yard.assetVisitYardEvent.Status Updated': 'Status Update',
  'core.yard.assetVisitYardEvent.Unassigned': 'Unassigned',
  'core.yard.labels.dotNumber': 'DOT Number',
  'core.yard.labels.licensePlate': 'License Plate',
  'core.yard.loadTypeDirections.inOut': 'Inbound/Outbound',
  'core.yard.loadTypeDirections.inbound': 'Inbound',
  'core.yard.loadTypeDirections.outbound': 'Outbound',
  'core.yard.messages.blockReasons.anotherAssetInTransitForDestination':
    '**{assetCode}** is already in transit to this spot.',
  'core.yard.messages.blockReasons.assetInTransitElsewhere':
    'Asset already being moved by another move task.',
  'core.yard.messages.blockReasons.destinationClosed': 'Destination spot is **closed**.',
  'core.yard.messages.blockReasons.destinationOccupied':
    'Destination spot is **occupied** by another asset.',
  'core.yard.messages.blockReasons.reservedByOther':
    'Destination spot is **reserved** to **Move Task #{taskNumber}**.',
  'core.yard.messages.blockReasons.reservedByOtherGeneric': 'Destination spot is **reserved**.',
  'core.yard.messages.blockedUntilSpotIsOpen': 'Blocked until {spot} is open',
  'core.yard.messages.failedToLoadSpotDetails': 'Failed to load spot details',
  'core.yard.messages.noInformationAvailable': 'No information available',
  'core.yard.messages.noVisitFound': 'No visit found',
  'core.yard.messages.notInformed': 'Not informed',
  'core.yard.messages.retry': 'Retry',
  'core.yard.messages.unhooked': 'Unhooked',
  'core.yard.messages.unknownCompany': 'Unknown Company',
  'core.yard.messages.waitingAssignment': 'Waiting assignment',
  'core.yard.spotStatuses.assigned': 'assigned',
  'core.yard.spotStatuses.closed': 'closed',
  'core.yard.spotStatuses.inTransit': 'in transit',
  'core.yard.spotStatuses.open': 'open',
  'core.yard.spotStatuses.reservedAutomated': 'reserved',
  'core.yard.spotStatuses.reservedManual': 'reserved',
  'core.yard.spotStatuses.unknown': 'unknown',
  'core.yard.spotTypes.docking': 'docking',
  'core.yard.spotTypes.parking': 'parking'
};
